import axios from 'utils/axios';
import _ from 'lodash';
import { getCountryIsoCode } from '../utils/country';

const getQuestionnaires = payload => {
  return axios.get('/questionnaire', { params: payload })
    .then(
      res => {
        return res.data;
      }
    )
    .catch((e) => {
      return e.response.data;
    });
};

const getQuestionnaire = (id, language) => {
  const langParam = language ? `?lang=${language}` : '';
  return axios.get(`/questionnaire/${id}` + langParam)
    .then(
      res => {
        return res.data;
      }
    )
    .catch((e) => {
      return e.response.data;
    });
};

const createQuestionnaire = (payload) => {
  const formData = new FormData();
  formData.append('lang', payload.lang);
  formData.append('data', JSON.stringify(payload));

  _.forEach(payload.questions, (question, index) => {
    if (question.file) {
      formData.append(index, question.file);
    }
  });

  return axios.post('/questionnaire', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(
      res => {
        return res.data;
      }
    )
    .catch((e) => {
      return e.response.data;
    });
};

const updateQuestionnaire = (id, payload) => {
  const formData = new FormData();
  formData.append('lang', payload.lang);
  formData.append('data', JSON.stringify(payload));

  _.forEach(payload.questions, (question, index) => {
    const { file, id } = question;

    // Skip if an existing file already has an ID
    if (file?.id) return;

    // Append either new file or mark as having no file
    if (file instanceof File) {
      formData.append(index, file);
    } else {
      formData.append('no_file_questions[]', id);
    }
  });

  return axios.post(`/questionnaire/${id}?_method=PUT`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then(
      res => {
        return res.data;
      }
    )
    .catch((e) => {
      return e.response.data;
    });
};

const deleteQuestionnaire = id => {
  return axios.delete(`/questionnaire/${id}`)
    .then(
      res => {
        return res.data;
      }
    )
    .catch((e) => {
      return e.response.data;
    });
};

const approveTranslation = (id, payload) => {
  const formData = new FormData();
  formData.append('lang', payload.lang);
  formData.append('data', JSON.stringify(payload));

  return axios.post(`/questionnaire/approve-translate/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(
    res => {
      return res.data;
    }
  ).catch((e) => {
    return e.response.data;
  });
};

const rejectTranslation = id => {
  return axios.delete(`/questionnaire/${id}`)
    .then(
      res => {
        return res.data;
      }
    )
    .catch((e) => {
      return e.response.data;
    });
};

const downloadQuestionnaireResults = (language, countryId) => {
  return axios.get('/export', { params: { lang: language, type: 'questionnaire_result' }, headers: { country: getCountryIsoCode(countryId) } })
    .then(
      res => {
        return res.data;
      }
    )
    .catch((e) => {
      return e.response.data;
    });
};

export const Questionnaire = {
  getQuestionnaire,
  getQuestionnaires,
  createQuestionnaire,
  updateQuestionnaire,
  deleteQuestionnaire,
  downloadQuestionnaireResults,
  approveTranslation,
  rejectTranslation
};
